module.exports = __webpack_public_path__ + "img/img3.74b187ae.png";